export const ADMIN_CONSOLE_USER_ROLES_CONSTANTS = {
  DISTRICT_ADMIN: "district_admin",
  SCHOOL_ADMIN: "principal",
  TEACHER: "teacher",
  STUDENT: "student",
};

export enum FE_USER_ROLES_CONSTANTS {
  DISTRICT_ADMIN = "District admin",
  SCHOOL_ADMIN = "School admin",
  PRINCIPAL = "School admin",
  TEACHER = "Teacher",
  STUDENT = "Student",
}
